// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Accordion from "@insite/mobius/Accordion";
import { AccordionSectionPresentationProps, ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, PropsWithChildren } from "react";

interface OwnProps {
    title?: string;
    expandByDefault?: boolean;
    type?: "widget" | "component";
}

export interface ToggleFiltersStyles {
    container?: InjectableCss;
    accordionSection?: AccordionSectionPresentationProps;
}

export const toggleFiltersStyles: ToggleFiltersStyles = {};

const styles = toggleFiltersStyles;
const ToggleFilters: FC<PropsWithChildren<OwnProps>> = ({
    title = translate("Filter Results"),
    expandByDefault = false,
    children,
    type = "component",
}) => {
    return (
        <StyledWrapper data-test-selector="toggle-filters-widget" {...styles.container}>
            <Accordion headingLevel={1}>
                <ManagedAccordionSection
                    title={title}
                    initialExpanded={expandByDefault}
                    onTogglePanel={() => {}}
                    {...styles.accordionSection}
                >
                    <>
                        {type === "component" && (
                            <StyledWrapper className="toggle-children-component">{children}</StyledWrapper>
                        )}
                        {type === "widget" && children}
                    </>
                </ManagedAccordionSection>
            </Accordion>
        </StyledWrapper>
    );
};

export default ToggleFilters;
